module.exports = "pegasus_template/assets/tech/holiday/100.png";